module.exports = __webpack_public_path__ + "img/type_xg.520625d0.png";